import { Pagination } from '@/modules/shared/schemas/Pagination'
import { PersonaTypeResponsibles } from '@/therapist/pages/tasks/types/Task'

import { axios, Response } from '../index'
import { AccessProfile, PersonaStatus } from '../operators/get-clinic-operators'

export type GetAResponsibleResponse = {
  id: string
  appUserId: number
  firstName: string
  lastName: string
  cpf: string
  birthday: string
  gender: 'MALE' | 'FEMALE' | 'OTHER' | 'DONT_WANT_TO_TELL'
  avatar: string
  avatarName: string
  accessProfiles: AccessProfile[]
  patients: PersonaTypeResponsibles[]
  responsibleType: string
  login: string
  personaStatus: PersonaStatus
}

const getAllResponsibles = ({
  page = 0,
  size = 10,
  personaName,
  accessProfileId,
  personaStatus
}: {
  page?: number
  size?: number
  personaName?: string
  accessProfileId?: number
  personaStatus?: PersonaStatus
} = {}): Response<Pagination<GetAResponsibleResponse[]>> => {
  const searchParams = new URLSearchParams()
  searchParams.set('page', page.toString())
  searchParams.set('size', size.toString())
  if (personaName) searchParams.set('personaName', personaName)
  if (accessProfileId)
    searchParams.set('accessProfileId', accessProfileId.toString())
  if (personaStatus) searchParams.set('personaStatus', personaStatus)

  return axios.get(`/v2/responsible?${searchParams.toString()}`)
}

export default getAllResponsibles
